import { defineRecipe } from "@chakra-ui/react";

export const linkRecipe = defineRecipe({
  base: {
    fontFamily: "body",
    padding: "5px 10px",
  },
  variants: {
    visual: {
      footerLink: {
        color: "mainText.200",
        fontWeight: "400",
      },
      blackLink: {
        color: "mainText.200",
        fontWeight: "300",
        _hover: {
          textDecorationColor: "mainText.200",
        },
      },
      underlineLink: {
        color: "mainText.200",
        textDecoration: "underline",
        transition: "all .5s",
        _hover: {
          color: "linkBlueC.100",
          transition: "all .5s",
        },
        _active: {
          color: "linkBlueC.200",
          transition: "all .5s",
        },
      },
      lawsLink: {
        color: "linkBlueC.100",
        textDecoration: "underline",
        transition: "all .5s",
        _hover: {
          textDecoration: "none",
          color: "linkBlueC.100",
          transition: "all .5s",
        },
        _active: {
          textDecoration: "none",
          color: "linkBlueC.300",
          transition: "all .5s",
        },
      },
    },
    size: {
      sm: {
        fontSize: "12px",
      },
      md: {
        fontSize: "14px",
      },
      lg: {
        fontSize: "16px",
      },
      xl: {
        fontSize: "20px",
      },
      "5xl": {
        fontSize: "50px",
      },
    },
  },
  defaultVariants: {
    visual: "blackLink",
    size: "lg",
  },
});
